import { render, staticRenderFns } from "./TaskViewHeader.vue?vue&type=template&id=3f90385b&scoped=true"
import script from "./TaskViewHeader.vue?vue&type=script&lang=js"
export * from "./TaskViewHeader.vue?vue&type=script&lang=js"
import style0 from "./TaskViewHeader.vue?vue&type=style&index=0&id=3f90385b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90385b",
  null
  
)

export default component.exports